import { Select, SelectProps } from '@mantine/core';
import { capitalize } from '@utils/strings';

import { useGetNationsQuery } from '@api/locations.api';

export default function NationSelector(props: SelectProps) {
  const { data = [], isLoading } = useGetNationsQuery(undefined, {
    skip: props.disabled,
  });

  return (
    <Select
      label="Nazione"
      placeholder="Seleziona nazione"
      data={data
        .toSorted((a, b) => (a.nome > b.nome ? 1 : -1))
        .map((nation) => ({
          value: nation.sigla,
          label: capitalize(nation.nome),
        }))}
      searchable
      {...props}
      disabled={isLoading || props.disabled}
    />
  );
}
